import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type ExamBoardMarkerProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function ExamBoardMarkerIcon({
  className,
  pathClassName = "stroke-textPrimary",
  ...props
}: ExamBoardMarkerProps) {
  return (
    <Svg
      width={20}
      height={21}
      viewBox="0 0 20 21"
      fill="none"
      {...props}
      className={className}
    >
      <Path
        d="M10.597 3.546l.947-.753a.945.945 0 011.507.486l.36 1.26a.953.953 0 00.948.695h1.223a.943.943 0 01.8.374.957.957 0 01.147.876l-.455 1.354a.96.96 0 00.342 1.078l1.108.811a.952.952 0 01.392.773.96.96 0 01-.392.772l-1.108.81a.954.954 0 00-.342 1.079l.455 1.354a.959.959 0 01-.501 1.162.941.941 0 01-.446.088h-1.223a.943.943 0 00-.948.696l-.36 1.259a.956.956 0 01-.623.652.942.942 0 01-.884-.166l-.947-.753a.944.944 0 00-1.194 0l-.948.753a.947.947 0 01-1.507-.486l-.36-1.26a.954.954 0 00-.948-.695H4.418a.942.942 0 01-.8-.374.957.957 0 01-.148-.876l.455-1.354a.96.96 0 00-.341-1.078l-1.109-.81a.952.952 0 01-.392-.773.959.959 0 01.392-.773l1.109-.81a.954.954 0 00.34-1.079l-.397-1.383a.96.96 0 01.502-1.162.942.942 0 01.446-.087h1.222a.943.943 0 00.948-.696l.36-1.26a.954.954 0 01.635-.584.942.942 0 01.843.174l.948.754a.943.943 0 001.166-.048z"
        className={pathClassName}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M6.755 10.411l1.827 1.827a.692.692 0 00.983 0l3.68-3.681"
        className={pathClassName}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export default ExamBoardMarkerIcon;
